import * as React from 'react';
export function IconCarteBleue(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 39.687 18.521"
      aria-hidden={true}
      {...props}
    >
      <defs>
        <clipPath clipPathUnits="userSpaceOnUse" id="icon-carte-bleue_svg__a">
          <path
            d="M726.739 275.021c8.28 11.691 6.841 27.826-4.026 38.353-2.315 2.246-4.882 3.834-7.613 5.198h-14.589c-4.174 0-7.087-3.584-7.087-7.286l-.025-28.316c0-5.017 3.194-7.973 7.209-7.973l26.131.024"
            clipRule="evenodd"
          />
        </clipPath>
      </defs>
      <path
        d="M36.496 11.397V2.91c0-1.448-1.116-2.624-2.491-2.624H3.012C1.636.285.514 1.46.514 2.909v9.475c0 1.448 1.122 2.625 2.498 2.625h2.164v.82c0 1.327 1.015 2.407 2.265 2.407h29.458c1.253 0 2.274-1.08 2.274-2.406v-2.018c0-1.328-1.013-2.415-2.263-2.415h-.414"
        fill="#184285"
      />
      <path
        d="M36.91 11.682c1.091 0 1.979.956 1.979 2.13v2.018c0 1.17-.893 2.122-1.99 2.122H7.441c-1.092 0-1.98-.952-1.98-2.122v-1.106H3.012c-1.22 0-2.213-1.05-2.213-2.34V2.91c0-1.29.993-2.34 2.213-2.34h30.993c1.217 0 2.207 1.05 2.207 2.34v8.773zm-.13-.285V2.91C36.78 1.305 35.537 0 34.006 0H3.012C1.478 0 .23 1.305.23 2.909v9.475c0 1.604 1.248 2.91 2.782 2.91h2.164l-.285-.285v.82c0 1.485 1.144 2.692 2.55 2.692h29.458c1.411 0 2.559-1.207 2.559-2.691v-2.018c0-1.488-1.143-2.7-2.548-2.7h-.414l.285.285"
        fill="#fff"
      />
      <g
        clipPath="url(#icon-carte-bleue_svg__a)"
        transform="matrix(.32452 0 0 -.32452 -224.243 103.945)"
      >
        <path d="M735.019 312.211l-20.808 6.361h20.808v-6.361" fill="#b3dcf5" />
        <path
          d="M735.019 312.109l-21.139 6.463h.331l20.808-6.361v-.102"
          fill="#b3dcf5"
        />
        <path
          d="M735.019 312.008l-21.469 6.564h.33l21.139-6.463v-.101"
          fill="#b2dbf5"
        />
        <path
          d="M735.019 311.907l-21.8 6.665h.331l21.469-6.564v-.101"
          fill="#b1dbf5"
        />
        <path
          d="M735.019 311.806l-22.132 6.766h.332l21.8-6.665v-.101"
          fill="#b0daf4"
        />
        <path
          d="M735.019 311.706l-22.462 6.866h.33l22.132-6.766v-.1"
          fill="#afdaf4"
        />
        <path
          d="M735.019 311.604l-22.793 6.968h.331l22.462-6.866v-.102"
          fill="#aed9f4"
        />
        <path
          d="M735.019 311.503l-23.123 7.069h.33l22.793-6.968v-.101"
          fill="#add9f4"
        />
        <path
          d="M735.019 311.402l-23.454 7.17h.331l23.123-7.069v-.101"
          fill="#acd9f4"
        />
        <path
          d="M735.019 311.301l-23.785 7.271h.331l23.454-7.17v-.101"
          fill="#abd8f4"
        />
        <path
          d="M735.019 311.2l-24.116 7.372h.331l23.785-7.271v-.101"
          fill="#aad8f4"
        />
        <path
          d="M735.019 311.098l-24.447 7.474h.331l24.116-7.372v-.102"
          fill="#a9d7f3"
        />
        <path
          d="M735.019 310.997l-24.778 7.575h.331l24.447-7.474v-.101"
          fill="#a8d7f3"
        />
        <path
          d="M735.019 310.896l-25.109 7.676h.331l24.778-7.575v-.101"
          fill="#a7d6f3"
        />
        <path
          d="M735.019 310.794l-25.44 7.778h.331l25.109-7.676v-.102"
          fill="#a6d6f3"
        />
        <path
          d="M735.019 310.693l-25.771 7.879h.331l25.44-7.778v-.101"
          fill="#a5d6f3"
        />
        <path
          d="M735.019 310.592l-26.102 7.98h.331l25.771-7.879v-.101"
          fill="#a4d5f3"
        />
        <path
          d="M735.019 310.492l-26.431 8.08h.329l26.102-7.98v-.1"
          fill="#a3d5f3"
        />
        <path
          d="M735.019 310.39l-26.762 8.182h.331l26.431-8.08v-.102"
          fill="#a2d4f3"
        />
        <path
          d="M735.019 310.29l-27.093 8.282h.331l26.762-8.182v-.1"
          fill="#a1d4f2"
        />
        <path
          d="M735.019 310.188l-27.424 8.384h.331l27.093-8.282v-.102"
          fill="#a0d3f2"
        />
        <path
          d="M735.019 310.087l-27.755 8.485h.331l27.424-8.384v-.101"
          fill="#9fd3f2"
        />
        <path
          d="M735.019 309.986l-28.086 8.586h.331l27.755-8.485v-.101"
          fill="#9ed3f2"
        />
        <path
          d="M735.019 309.885l-28.417 8.687h.331l28.086-8.586v-.101"
          fill="#9dd2f2"
        />
        <path
          d="M735.019 309.783l-28.748 8.789h.331l28.417-8.687v-.102"
          fill="#9cd2f2"
        />
        <path
          d="M735.019 309.682l-29.078 8.89h.33l28.748-8.789v-.101"
          fill="#9bd1f2"
        />
        <path
          d="M735.019 309.581l-29.41 8.991h.332l29.078-8.89v-.101"
          fill="#9ad1f2"
        />
        <path
          d="M735.019 309.48l-29.739 9.092h.329l29.41-8.991v-.101"
          fill="#99d0f1"
        />
        <path
          d="M735.019 309.378l-30.071 9.194h.332l29.739-9.092v-.102"
          fill="#98d0f1"
        />
        <path
          d="M735.019 309.277l-30.401 9.295h.33l30.071-9.194v-.101"
          fill="#97d0f1"
        />
        <path
          d="M735.019 309.176l-30.732 9.396h.331l30.401-9.295v-.101"
          fill="#96cff1"
        />
        <path
          d="M735.019 309.075l-31.064 9.497h.332l30.732-9.396v-.101"
          fill="#95cff1"
        />
        <path
          d="M735.019 308.975l-31.394 9.597h.33l31.064-9.497v-.1"
          fill="#94cef1"
        />
        <path
          d="M735.019 308.873l-31.725 9.699h.331l31.394-9.597v-.102"
          fill="#93cef1"
        />
        <path
          d="M735.019 308.772l-32.056 9.8h.331l31.725-9.699v-.101"
          fill="#92cdf1"
        />
        <path
          d="M735.019 308.671l-32.387 9.901h.331l32.056-9.8v-.101"
          fill="#91cdf0"
        />
        <path
          d="M735.019 308.57L702.3 318.572h.332l32.387-9.901v-.101"
          fill="#90cdf0"
        />
        <path
          d="M735.019 308.469l-33.049 10.103h.33l32.719-10.002v-.101"
          fill="#8fccf0"
        />
        <path
          d="M735.019 308.367l-33.379 10.205h.33l33.049-10.103v-.102"
          fill="#8eccf0"
        />
        <path
          d="M735.019 308.266l-33.71 10.306h.331l33.379-10.205v-.101"
          fill="#8dcbf0"
        />
        <path
          d="M735.019 308.165l-34.041 10.407h.331l33.71-10.306v-.101"
          fill="#8ccbf0"
        />
        <path
          d="M735.019 308.064l-34.371 10.508h.33l34.041-10.407v-.101"
          fill="#8bcbf0"
        />
        <path
          d="M735.019 307.962l-34.703 10.61h.332l34.371-10.508v-.102"
          fill="#8acaf0"
        />
        <path
          d="M735.019 307.861l-35.034 10.711h.331l34.703-10.61v-.101"
          fill="#89caef"
        />
        <path
          d="M735.019 307.76l-35.364 10.812h.33l35.034-10.711v-.101"
          fill="#88c9ef"
        />
        <path
          d="M735.019 307.66l-35.696 10.912h.332l35.364-10.812v-.1"
          fill="#87c9ef"
        />
        <path
          d="M735.019 307.557l-36.027 11.015h.331l35.696-10.912v-.103"
          fill="#86c9ef"
        />
        <path
          d="M735.019 307.457l-36.357 11.115h.33l36.027-11.015v-.1"
          fill="#85c8ef"
        />
        <path
          d="M735.019 307.356l-36.689 11.216h.332l36.357-11.115v-.101"
          fill="#84c8ef"
        />
        <path
          d="M735.019 307.255l-37.018 11.317h.329l36.689-11.216v-.101"
          fill="#83c7ef"
        />
        <path
          d="M735.019 307.154l-37.351 11.418h.333l37.018-11.317v-.101"
          fill="#82c7ef"
        />
        <path
          d="M735.019 307.052l-37.68 11.52h.329l37.351-11.418v-.102"
          fill="#81c6ee"
        />
        <path
          d="M735.019 306.951l-38.011 11.621h.331l37.68-11.52v-.101"
          fill="#80c6ee"
        />
        <path
          d="M735.019 306.85l-38.342 11.722h.331l38.011-11.621v-.101"
          fill="#7fc6ee"
        />
        <path
          d="M735.019 306.749l-38.673 11.823h.331l38.342-11.722v-.101"
          fill="#7ec5ee"
        />
        <path
          d="M735.019 306.647l-39.004 11.925h.331l38.673-11.823v-.102"
          fill="#7dc5ee"
        />
        <path
          d="M735.019 306.546l-39.335 12.026h.331l39.004-11.925v-.101"
          fill="#7cc4ee"
        />
        <path
          d="M735.019 306.445l-39.666 12.127h.331l39.335-12.026v-.101"
          fill="#7bc4ee"
        />
        <path
          d="M735.019 306.345l-39.997 12.227h.331l39.666-12.127v-.1"
          fill="#7ac4ee"
        />
        <path
          d="M735.019 306.242l-40.327 12.33h.33l39.997-12.227v-.103"
          fill="#79c3ed"
        />
        <path
          d="M735.019 306.143l-40.657 12.429h.33l40.327-12.33v-.099"
          fill="#78c3ed"
        />
        <path
          d="M735.019 306.042l-40.99 12.53h.333l40.657-12.429v-.101"
          fill="#78c2ed"
        />
        <path
          d="M735.019 305.94l-41.31 12.629.001.003h.319l40.99-12.53v-.102"
          fill="#77c2ed"
        />
        <path
          d="M735.019 305.839l-41.337 12.638.027.092 41.31-12.629v-.101"
          fill="#76c2ed"
        />
        <path
          d="M735.019 305.738l-41.366 12.646.029.093 41.337-12.638v-.101"
          fill="#75c1ed"
        />
        <path
          d="M735.019 305.636l-41.395 12.656.029.092 41.366-12.646v-.102"
          fill="#74c1ed"
        />
        <path
          d="M735.019 305.535L693.597 318.2l.027.092 41.395-12.656v-.101"
          fill="#73c0ed"
        />
        <path
          d="M735.019 305.434l-41.451 12.672.029.094 41.422-12.665v-.101"
          fill="#72c0ec"
        />
        <path
          d="M735.019 305.333l-41.48 12.681.029.092 41.451-12.672v-.101"
          fill="#71c0ec"
        />
        <path
          d="M735.019 305.231l-41.508 12.691.028.092 41.48-12.681v-.102"
          fill="#70bfec"
        />
        <path
          d="M735.019 305.13l-41.535 12.7.027.092 41.508-12.691v-.101"
          fill="#6fbfec"
        />
        <path
          d="M735.019 305.029l-41.564 12.708.029.093 41.535-12.7v-.101"
          fill="#6ebfec"
        />
        <path
          d="M735.019 304.928l-41.593 12.716.029.093 41.564-12.708v-.101"
          fill="#6dbeec"
        />
        <path
          d="M735.019 304.828l-41.62 12.724v.001l.027.091 41.593-12.716v-.1"
          fill="#6cbeec"
        />
        <path
          d="M735.019 304.727l-41.62 12.723v.102l41.62-12.724v-.101"
          fill="#6bbdec"
        />
        <path
          d="M735.019 304.625l-41.62 12.724v.101l41.62-12.723v-.102"
          fill="#6abdeb"
        />
        <path
          d="M735.019 304.524l-41.62 12.724v.101l41.62-12.724v-.101"
          fill="#69bdeb"
        />
        <path
          d="M735.019 304.423l-41.62 12.724v.101l41.62-12.724v-.101"
          fill="#68bceb"
        />
        <path
          d="M735.019 304.32l-41.62 12.725v.102l41.62-12.724v-.103"
          fill="#68bceb"
        />
        <path
          d="M735.019 304.219l-41.62 12.725v.101l41.62-12.725v-.101"
          fill="#67baea"
        />
        <path
          d="M735.019 304.117l-41.62 12.724v.103l41.62-12.725v-.102"
          fill="#65b8e8"
        />
        <path
          d="M735.019 304.015l-41.62 12.725v.101l41.62-12.724v-.102"
          fill="#64b5e7"
        />
        <path
          d="M735.019 303.913l-41.62 12.724v.103l41.62-12.725v-.102"
          fill="#62b3e5"
        />
        <path
          d="M735.019 303.812l-41.62 12.724v.101l41.62-12.724v-.101"
          fill="#61b1e4"
        />
        <path
          d="M735.019 303.71l-41.62 12.725v.101l41.62-12.724v-.102"
          fill="#60afe2"
        />
        <path
          d="M735.019 303.608l-41.62 12.724v.103l41.62-12.725v-.102"
          fill="#5eade1"
        />
        <path
          d="M735.019 303.507l-41.62 12.724v.101l41.62-12.724v-.101"
          fill="#5daadf"
        />
        <path
          d="M735.019 303.404l-41.62 12.725v.102l41.62-12.724v-.103"
          fill="#5ca8de"
        />
        <path
          d="M735.019 303.303l-41.62 12.724v.102l41.62-12.725v-.101"
          fill="#5aa6dc"
        />
        <path
          d="M735.019 303.202l-41.62 12.723v.102l41.62-12.724v-.101"
          fill="#59a4db"
        />
        <path
          d="M735.019 303.099l-41.62 12.725v.101l41.62-12.723v-.103"
          fill="#58a2d9"
        />
        <path
          d="M735.019 302.998l-41.62 12.723v.103l41.62-12.725v-.101"
          fill="#57a1d8"
        />
        <path
          d="M735.019 302.895l-41.62 12.725v.101l41.62-12.723v-.103"
          fill="#559fd7"
        />
        <path
          d="M735.019 302.794l-41.62 12.725v.101l41.62-12.725v-.101"
          fill="#549dd5"
        />
        <path
          d="M735.019 302.692l-41.62 12.724v.103l41.62-12.725v-.102"
          fill="#539bd4"
        />
        <path
          d="M735.019 302.59l-41.62 12.725v.101l41.62-12.724v-.102"
          fill="#5299d3"
        />
        <path
          d="M735.019 302.488l-41.62 12.726v.101l41.62-12.725v-.102"
          fill="#5197d1"
        />
        <path
          d="M735.019 302.386l-41.62 12.725v.103l41.62-12.726v-.102"
          fill="#5096d0"
        />
        <path
          d="M735.019 302.284l-41.62 12.725v.102l41.62-12.725v-.102"
          fill="#4f94cf"
        />
        <path
          d="M735.019 302.183l-41.62 12.724v.102l41.62-12.725v-.101"
          fill="#4e92ce"
        />
        <path
          d="M735.019 302.08l-41.62 12.725v.102l41.62-12.724v-.103"
          fill="#4c91cc"
        />
        <path
          d="M735.019 301.979l-41.62 12.724v.102l41.62-12.725v-.101"
          fill="#4b8fcb"
        />
        <path
          d="M735.019 301.878l-41.62 12.723v.102l41.62-12.724v-.101"
          fill="#4a8dca"
        />
        <path
          d="M735.019 301.775l-41.62 12.725v.101l41.62-12.723v-.103"
          fill="#498cc9"
        />
        <path
          d="M735.019 301.674l-41.62 12.723v.103l41.62-12.725v-.101"
          fill="#488ac8"
        />
        <path
          d="M735.019 301.572l-41.62 12.724v.101l41.62-12.723v-.102"
          fill="#4789c6"
        />
        <path
          d="M735.019 301.47l-41.62 12.725v.101l41.62-12.724v-.102"
          fill="#4687c5"
        />
        <path
          d="M735.019 301.368l-41.62 12.724v.103l41.62-12.725v-.102"
          fill="#4586c4"
        />
        <path
          d="M735.019 301.267l-41.62 12.724v.101l41.62-12.724v-.101"
          fill="#4584c3"
        />
        <path
          d="M735.019 301.164l-41.62 12.725v.102l41.62-12.724v-.103"
          fill="#4483c2"
        />
        <path
          d="M735.019 301.063l-41.62 12.724v.102l41.62-12.725v-.101"
          fill="#4381c1"
        />
        <path
          d="M735.019 300.96l-41.62 12.726v.101l41.62-12.724v-.103"
          fill="#4280c0"
        />
        <path
          d="M735.019 300.859l-41.62 12.725v.102l41.62-12.726v-.101"
          fill="#417fbf"
        />
        <path
          d="M735.019 300.758l-41.62 12.724v.102l41.62-12.725v-.101"
          fill="#407dbd"
        />
        <path
          d="M735.019 300.655l-41.62 12.725v.102l41.62-12.724v-.103"
          fill="#3f7cbc"
        />
        <path
          d="M735.019 300.554l-41.62 12.725v.101l41.62-12.725v-.101"
          fill="#3e7bbb"
        />
        <path
          d="M735.019 300.453l-41.62 12.723v.103l41.62-12.725v-.101"
          fill="#3e79ba"
        />
        <path
          d="M735.019 300.35l-41.62 12.725v.101l41.62-12.723v-.103"
          fill="#3d78b9"
        />
        <path
          d="M735.019 300.248l-41.62 12.724v.103l41.62-12.725v-.102"
          fill="#3c77b8"
        />
        <path
          d="M735.019 300.147l-41.62 12.724v.101l41.62-12.724v-.101"
          fill="#3b76b7"
        />
        <path
          d="M735.019 300.044l-41.62 12.726v.101l41.62-12.724v-.103"
          fill="#3a75b6"
        />
        <path
          d="M735.019 299.943l-41.62 12.724v.103l41.62-12.726v-.101"
          fill="#3a73b5"
        />
        <path
          d="M735.019 299.841l-41.62 12.725v.101l41.62-12.724v-.102"
          fill="#3972b4"
        />
        <path
          d="M735.019 299.739l-41.62 12.725v.102l41.62-12.725v-.102"
          fill="#3871b3"
        />
        <path
          d="M735.019 299.638l-41.62 12.724v.102l41.62-12.725v-.101"
          fill="#3770b2"
        />
        <path
          d="M735.019 299.535l-41.62 12.725v.102l41.62-12.724v-.103"
          fill="#376fb2"
        />
        <path
          d="M735.019 299.434l-41.62 12.724v.102l41.62-12.725v-.101"
          fill="#366eb1"
        />
        <path
          d="M735.019 299.333l-41.62 12.723v.102l41.62-12.724v-.101"
          fill="#356db0"
        />
        <path
          d="M735.019 299.23l-41.62 12.725v.101l41.62-12.723v-.103"
          fill="#356caf"
        />
        <path
          d="M735.019 299.129l-41.62 12.723v.103l41.62-12.725v-.101"
          fill="#346bae"
        />
        <path
          d="M735.019 299.028l-41.62 12.723v.101l41.62-12.723v-.101"
          fill="#336aad"
        />
        <path
          d="M735.019 298.925l-41.62 12.725v.101l41.62-12.723v-.103"
          fill="#3369ac"
        />
        <path
          d="M735.019 298.824l-41.62 12.723v.103l41.62-12.725v-.101"
          fill="#3268ab"
        />
        <path
          d="M735.019 298.722l-41.62 12.724v.101l41.62-12.723v-.102"
          fill="#3167ab"
        />
        <path
          d="M735.019 298.619l-41.62 12.726v.101l41.62-12.724v-.103"
          fill="#3166aa"
        />
        <path
          d="M735.019 298.518l-41.62 12.724v.103l41.62-12.726v-.101"
          fill="#3065a9"
        />
        <path
          d="M735.019 298.415l-41.62 12.726v.101l41.62-12.724v-.103"
          fill="#3064a8"
        />
        <path
          d="M735.019 298.314l-41.62 12.725v.102l41.62-12.726v-.101"
          fill="#2f63a7"
        />
        <path
          d="M735.019 298.213l-41.62 12.723v.103l41.62-12.725v-.101"
          fill="#2e62a7"
        />
        <path
          d="M735.019 298.11l-41.62 12.725v.101l41.62-12.723v-.103"
          fill="#2e62a6"
        />
        <path
          d="M735.019 298.009l-41.62 12.725v.101l41.62-12.725v-.101"
          fill="#2d61a5"
        />
        <path
          d="M735.019 297.906l-41.62 12.725v.103l41.62-12.725v-.103"
          fill="#2d60a4"
        />
        <path
          d="M735.019 297.805l-41.62 12.725v.101l41.62-12.725v-.101"
          fill="#2c5fa4"
        />
        <path
          d="M735.019 297.704l-41.62 12.723v.103l41.62-12.725v-.101"
          fill="#2c5ea3"
        />
        <path
          d="M735.019 297.601l-41.62 12.725v.101l41.62-12.723v-.103"
          fill="#2b5ea2"
        />
        <path
          d="M735.019 297.499l-41.62 12.724v.103l41.62-12.725v-.102"
          fill="#2b5da1"
        />
        <path
          d="M735.019 297.398l-41.62 12.724v.101l41.62-12.724v-.101"
          fill="#2a5ca1"
        />
        <path
          d="M735.019 297.295l-41.62 12.726v.101l41.62-12.724v-.103"
          fill="#2a5ba0"
        />
        <path
          d="M735.019 297.194l-41.62 12.724v.103l41.62-12.726v-.101"
          fill="#295b9f"
        />
        <path
          d="M735.019 297.093l-41.62 12.724v.101l41.62-12.724v-.101"
          fill="#295a9f"
        />
        <path
          d="M735.019 296.99l-41.62 12.725v.102l41.62-12.724v-.103"
          fill="#28599e"
        />
        <path
          d="M735.019 296.889l-41.62 12.724v.102l41.62-12.725v-.101"
          fill="#28599d"
        />
        <path
          d="M735.019 296.788l-41.62 12.724v.101l41.62-12.724v-.101"
          fill="#27589d"
        />
        <path
          d="M735.019 296.685l-41.62 12.725v.102l41.62-12.724v-.103"
          fill="#27579c"
        />
        <path
          d="M735.019 296.584l-41.62 12.723v.103l41.62-12.725v-.101"
          fill="#27579c"
        />
        <path
          d="M735.019 296.481l-41.62 12.725v.101l41.62-12.723v-.103"
          fill="#26569b"
        />
        <path
          d="M735.019 296.38l-41.62 12.725v.101l41.62-12.725v-.101"
          fill="#26559a"
        />
        <path
          d="M735.019 296.278l-41.62 12.724v.103l41.62-12.725v-.102"
          fill="#25559a"
        />
        <path
          d="M735.019 296.176l-41.62 12.725v.101l41.62-12.724v-.102"
          fill="#255499"
        />
        <path
          d="M735.019 296.074l-41.62 12.726v.101l41.62-12.725v-.102"
          fill="#255499"
        />
        <path
          d="M735.019 295.973l-41.62 12.724v.103l41.62-12.726v-.101"
          fill="#245398"
        />
        <path
          d="M735.019 295.87l-41.62 12.726v.101l41.62-12.724v-.103"
          fill="#245397"
        />
        <path
          d="M735.019 295.769l-41.62 12.724v.103l41.62-12.726v-.101"
          fill="#235297"
        />
        <path
          d="M735.019 295.668l-41.62 12.724v.101l41.62-12.724v-.101"
          fill="#235296"
        />
        <path
          d="M735.019 295.565l-41.62 12.725v.102l41.62-12.724v-.103"
          fill="#235196"
        />
        <path
          d="M735.019 295.464l-41.62 12.723v.103l41.62-12.725v-.101"
          fill="#225095"
        />
        <path
          d="M735.019 295.361l-41.62 12.725v.101l41.62-12.723v-.103"
          fill="#225095"
        />
        <path
          d="M735.019 295.26l-41.62 12.725v.101l41.62-12.725v-.101"
          fill="#225094"
        />
        <path
          d="M735.019 295.158l-41.62 12.724v.103l41.62-12.725v-.102"
          fill="#214f94"
        />
        <path
          d="M735.019 295.056l-41.62 12.725v.101l41.62-12.724v-.102"
          fill="#214f93"
        />
        <path
          d="M735.019 294.954l-41.62 12.724v.103l41.62-12.725v-.102"
          fill="#214e93"
        />
        <path
          d="M735.019 294.853l-41.62 12.724v.101l41.62-12.724v-.101"
          fill="#204e92"
        />
        <path
          d="M735.019 294.751l-41.62 12.725v.101l41.62-12.724v-.102"
          fill="#204d92"
        />
        <path
          d="M735.019 294.649l-41.62 12.724v.103l41.62-12.725v-.102"
          fill="#204d92"
        />
        <path
          d="M735.019 294.548l-41.62 12.724v.101l41.62-12.724v-.101"
          fill="#204c91"
        />
        <path
          d="M735.019 294.445l-41.62 12.725v.102l41.62-12.724v-.103"
          fill="#1f4c91"
        />
        <path
          d="M735.019 294.344l-41.62 12.724v.102l41.62-12.725v-.101"
          fill="#1f4c90"
        />
        <path
          d="M735.019 294.243l-41.62 12.723v.102l41.62-12.724v-.101"
          fill="#1f4b90"
        />
        <path
          d="M735.019 294.14l-41.62 12.725v.101l41.62-12.723v-.103"
          fill="#1e4b8f"
        />
        <path
          d="M735.019 294.039l-41.62 12.723v.103l41.62-12.725v-.101"
          fill="#1e4a8f"
        />
        <path
          d="M735.019 293.936l-41.62 12.725v.101l41.62-12.723v-.103"
          fill="#1e4a8f"
        />
        <path
          d="M735.019 293.835l-41.62 12.725v.101l41.62-12.725v-.101"
          fill="#1e4a8e"
        />
        <path
          d="M735.019 293.733l-41.62 12.724v.103l41.62-12.725v-.102"
          fill="#1d498e"
        />
        <path
          d="M735.019 293.631l-41.62 12.725v.101l41.62-12.724v-.102"
          fill="#1d498e"
        />
        <path
          d="M735.019 293.529l-41.62 12.725v.102l41.62-12.725v-.102"
          fill="#1d498d"
        />
        <path
          d="M735.019 293.426l-41.62 12.726v.102l41.62-12.725v-.103"
          fill="#1d488d"
        />
        <path
          d="M735.019 293.325l-41.62 12.725v.102l41.62-12.726v-.101"
          fill="#1d488d"
        />
        <path
          d="M735.019 293.224l-41.62 12.724v.102l41.62-12.725v-.101"
          fill="#1c488c"
        />
        <path
          d="M735.019 293.121l-41.62 12.725v.102l41.62-12.724v-.103"
          fill="#1c488c"
        />
        <path
          d="M735.019 293.02l-41.62 12.724v.102l41.62-12.725v-.101"
          fill="#1c478c"
        />
        <path
          d="M735.019 292.919l-41.62 12.723v.102l41.62-12.724v-.101"
          fill="#1c478b"
        />
        <path
          d="M735.019 292.816l-41.62 12.725v.101l41.62-12.723v-.103"
          fill="#1c478b"
        />
        <path
          d="M735.019 292.715l-41.62 12.723v.103l41.62-12.725v-.101"
          fill="#1b468b"
        />
        <path
          d="M735.019 292.613l-41.62 12.724v.101l41.62-12.723v-.102"
          fill="#1b468a"
        />
        <path
          d="M735.019 292.511l-41.62 12.725v.101l41.62-12.724v-.102M735.019 292.409l-41.62 12.724v.103l41.62-12.725v-.102"
          fill="#1b468a"
        />
        <path
          d="M735.019 292.308l-41.62 12.724v.101l41.62-12.724v-.101"
          fill="#1b458a"
        />
        <path
          d="M735.019 292.205l-41.62 12.725v.102l41.62-12.724v-.103"
          fill="#1b4589"
        />
        <path
          d="M735.019 292.104l-41.62 12.724v.102l41.62-12.725v-.101"
          fill="#1a4589"
        />
        <path
          d="M735.019 292.001l-41.62 12.726v.101l41.62-12.724v-.103"
          fill="#1a4589"
        />
        <path
          d="M735.019 291.9l-41.62 12.725v.102l41.62-12.726v-.101"
          fill="#1a4589"
        />
        <path
          d="M735.019 291.799l-41.62 12.724v.102l41.62-12.725v-.101"
          fill="#1a4488"
        />
        <path
          d="M735.019 291.696l-41.62 12.725v.102l41.62-12.724v-.103"
          fill="#1a4488"
        />
        <path
          d="M735.019 291.595l-41.62 12.725v.101l41.62-12.725v-.101"
          fill="#1a4488"
        />
        <path
          d="M735.019 291.494l-41.62 12.723v.103l41.62-12.725v-.101"
          fill="#1a4488"
        />
        <path
          d="M735.019 291.391l-41.62 12.725v.101l41.62-12.723v-.103"
          fill="#1a4488"
        />
        <path
          d="M735.019 291.29l-41.62 12.723v.103l41.62-12.725v-.101"
          fill="#194488"
        />
        <path
          d="M735.019 291.187l-41.62 12.725v.101l41.62-12.723v-.103"
          fill="#194387"
        />
        <path
          d="M735.019 291.086l-41.62 12.725v.101l41.62-12.725v-.101M735.019 290.984l-41.62 12.724v.103l41.62-12.725v-.102"
          fill="#194387"
        />
        <path
          d="M735.019 290.882l-41.62 12.725v.101l41.62-12.724v-.102M735.019 290.78l-41.62 12.725v.102l41.62-12.725v-.102M735.019 290.679l-41.62 12.724v.102l41.62-12.725v-.101"
          fill="#194387"
        />
        <path
          d="M735.019 290.576l-41.62 12.725v.102l41.62-12.724v-.103M735.019 290.475l-41.62 12.724v.102l41.62-12.725v-.101"
          fill="#194386"
        />
        <path
          d="M735.019 290.374l-41.62 12.723v.102l41.62-12.724v-.101"
          fill="#194286"
        />
        <path
          d="M735.019 290.271l-41.62 12.725v.101l41.62-12.723v-.103"
          fill="#194286"
        />
        <path
          d="M735.019 290.17l-41.62 12.723v.103l41.62-12.725v-.101"
          fill="#194286"
        />
        <path
          d="M735.019 290.069l-41.62 12.723v.101l41.62-12.723v-.101"
          fill="#184286"
        />
        <path
          d="M735.019 289.966l-41.62 12.725v.101l41.62-12.723v-.103M735.019 289.864l-41.62 12.724v.103l41.62-12.725v-.102"
          fill="#184286"
        />
        <path
          d="M735.019 289.763l-41.62 12.724v.101l41.62-12.724v-.101"
          fill="#184286"
        />
        <path
          d="M735.019 289.66l-41.62 12.726v.101l41.62-12.724v-.103"
          fill="#184286"
        />
        <path
          d="M735.019 289.559l-41.62 12.724v.103l41.62-12.726v-.101"
          fill="#184286"
        />
        <path
          d="M735.019 289.456l-41.62 12.726v.101l41.62-12.724v-.103"
          fill="#184286"
        />
        <path
          d="M735.019 289.355l-41.62 12.725v.102l41.62-12.726v-.101"
          fill="#184286"
        />
        <path
          d="M735.019 289.252l-41.62 12.725v.103l41.62-12.725v-.103"
          fill="#184286"
        />
        <path
          d="M735.019 289.151l-41.62 12.725v.101l41.62-12.725v-.101"
          fill="#184286"
        />
        <path
          d="M735.019 289.05l-41.62 12.723v.103l41.62-12.725v-.101"
          fill="#184285"
        />
        <path
          d="M735.019 288.947l-41.62 12.725v.101l41.62-12.723v-.103"
          fill="#184285"
        />
        <path
          d="M735.019 288.846l-41.62 12.725v.101l41.62-12.725v-.101M735.019 284.065l-2.772-9.067h-38.848v26.573l41.62-12.725v-4.781"
          fill="#184285"
        />
      </g>
      <path
        d="M3.481 2.993c-.028-.173-.211-.303-.422-.303-.384 0-.526.29-.526.596 0 .29.142.583.526.583.26 0 .406-.162.437-.39h.412c-.043.433-.375.713-.849.713-.599 0-.951-.404-.951-.906 0-.518.352-.92.951-.92.425 0 .782.224.835.627H3.48M2.723 5.751h.502l-.244-.636h-.006zm.04-1.065h.438l.722 1.74h-.44l-.148-.387h-.723l-.15.387h-.43l.732-1.74M2.612 7.723h.467c.19 0 .292-.073.292-.248 0-.168-.103-.242-.292-.242h-.467zm-.424-.788H3.23c.347 0 .566.217.566.482 0 .204-.09.356-.304.433v.007c.207.048.267.233.28.409.008.106.005.313.081.411h-.426c-.052-.111-.045-.278-.067-.417-.029-.184-.109-.263-.322-.263h-.426v.68h-.424V6.935M2.773 9.521h-.581v-.323h1.586v.323h-.582v1.421h-.423V9.521M2.265 13.14h1.47v-.321H2.69v-.427h.938v-.298H2.69v-.373h1.022v-.322H2.265v1.741"
        fill="#fff"
      />
      <path
        d="M5.445 14.766v-.93c0-1.19.935-2.157 2.051-2.157H36.22v.968c0 1.132-.832 2.052-1.777 2.112l-28.998.008"
        fill="#68bceb"
      />
      <path
        d="M38.886 13.81c0-1.193-.9-2.138-2.019-2.138h-.646v.933c0 1.094-.766 1.986-1.76 2.114H5.453v1.088c0 1.192.913 2.159 2.031 2.159h29.37c1.121 0 2.033-.967 2.033-2.16V13.81"
        fill="#b3dcf5"
      />
      <path
        d="M26.993 2.302v3.54c0 .656.123 1.342-1.428 1.342-1.46 0-1.423-.616-1.423-1.341V2.268h-1.388v3.575c0 1.437.777 2.554 2.8 2.554 2.236 0 2.824-1.282 2.824-2.554v-3.54h-1.385M16.296 8.326v-1.12H13.79c-.199-.002-.36-.133-.375-.307V2.27h-1.547v4.856h.004c0 .665.603 1.197 1.35 1.2h3.075"
        fill="#fff"
        fillRule="evenodd"
      />
      <path
        d="M21.58 3.439V2.268h-4.479v4.839c0 .663.612 1.203 1.362 1.203h3.103V7.24h-2.917V5.736h2.917v-1.05h-2.917V3.439h2.932M34.062 3.439V2.268h-4.486v4.839c0 .663.614 1.203 1.366 1.203h3.107V7.24h-2.925V5.736h2.925v-1.05h-2.925V3.439h2.938"
        fill="#fff"
      />
      <path
        d="M6.042 5.836v1.413h2.715c.527 0 .932-.22.932-.746 0-.574-.463-.667-.932-.667zm-.044-1.218h2.715c.34 0 .628-.186.628-.54 0-.411-.3-.516-.628-.516H5.998zM8.67 2.346c1.139 0 1.836.55 1.836 1.673 0 .376-.138.81-.407 1.078.326.258.708.642.708 1.42 0 1.214-.87 1.894-2.137 1.894H5.187V2.346H8.67"
        fill="#184285"
        fillRule="evenodd"
      />
      <path
        d="M6.407 5.75v1.415h2.207c.52 0 .93-.22.93-.747 0-.572-.464-.669-.93-.669zm0-1.218h2.207c.336 0 .625-.183.625-.54 0-.408-.3-.513-.625-.513H6.407zM8.614 2.26c1.138 0 1.833.551 1.833 1.674 0 .377-.14.81-.404 1.078.324.26.707.644.707 1.418 0 1.218-.87 1.898-2.136 1.898H5.198V2.26h3.416"
        fill="#fff"
        fillRule="evenodd"
      />
    </svg>
  );
}
